/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

/**
  * 1. Skip holes in route component chain and
  * only consider components that implement
  * fetchData or fetchDataDeferred
  *
  * 2. Pull out fetch data methods
  *
  * 3. Call fetch data methods and gather promises
  */
'use strict';

exports.__esModule = true;

exports['default'] = function (components, getState, dispatch, location, params, deferred) {
  var methodName = deferred ? 'fetchDataDeferred' : 'fetchData';

  return components.filter(function (component) {
    return component && component[methodName];
  }) // 1
  .map(function (component) {
    return component[methodName];
  }) // 2
  .map(function (fetchData) {
    return fetchData(getState, dispatch, location, params);
  }); // 3
};

module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/getDataDependencies.js
 ** module id = 714
 ** module chunks = 0
 **/